module.exports = __webpack_public_path__ + "static/img/space-elevator_256.c3b05bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/space-elevator_256.png
// module id = tfQS
// module chunks = 0